import React from 'react';

import {Box, Container, Link, Stack} from 'views/components';
import {translate} from 'views/module';

const Footer = () => {
  const links = [
    {label: translate('jobBoard.Footer.About'), href: 'https://carequilt.ca/about'},
    {label: translate('jobBoard.Footer.FAQ'), href: 'https://carequilt.ca/faq'},
    {label: translate('jobBoard.Footer.Contact'), href: 'https://carequilt.ca/contact'},
    {label: translate('jobBoard.Footer.ForCareGivers'), href: 'https://carequilt.ca/caregiver'},
    {label: translate('jobBoard.Footer.TermsConditions'), href: 'https://carequilt.ca/Terms&Conditions'},
    {label: translate('jobBoard.Footer.PrivacyPolicy'), href: 'https://carequilt.ca/privacy-policy'},
  ];

  return (
    <Box
      component="footer"
      sx={{
        // Typography
        fontFamily: 'sans-serif',
        fontSize: '12px',
        WebkitFontSmoothing: 'inherit',

        // Layout
        boxSizing: 'border-box',
        display: 'flex',
        flexFlow: 'row',
        flex: 'none',
        order: 1002,
        placeContent: 'center',
        alignItems: 'center',
        gap: '10px',
        width: '100%',
        p: '20px 50px',

        // Border (top only)
        borderStyle: 'solid',
        borderColor: '#da7757',
        borderTopWidth: '1px',
        borderRightWidth: 0,
        borderBottomWidth: 0,
        borderLeftWidth: 0,

        // Misc
        height: 'min-content',
        overflow: 'clip',
        position: 'relative',
      }}
    >
      <Container maxWidth="lg">
        <Stack
          direction={{xs: 'column', sm: 'row'}}
          spacing={{xs: 1.5, sm: 3}}
          useFlexGap
          flexWrap="wrap"
          sx={{alignItems: {xs: 'flex-start', sm: 'center'}}}
        >
          {links.map((l, i) => (
            <Link href={l.href} key={i}
              sx={{
                'whiteSpace': 'pre',
                'letterSpacing': '0px',
                'lineHeight': '1.4em',
                'textAlign': 'left',
                'fontFamily': '"Roboto","Roboto Placeholder",sans-serif',
                'fontStyle': 'normal',
                'fontWeight': 400,
                'fontSize': '16px',
                'color': '#616161',
                'textDecoration': 'underline',
                '&:hover': {
                  color: '#000',
                },
                '&.isCurrent, &[aria-current=\'page\']': {
                  color: '#111',
                },
              }}
            >
              {l.label}
            </Link>
          ))}
        </Stack>
      </Container>
    </Box>
  );
};

Footer.propTypes = {};

export default Footer;
